<template>
  <div class="OverviewsStatisticsDownload flex justify-start items-start flex-col w-full">
    <div 
      class="OverviewsItem hover:bg-gray-100 w-full border-b border-gray-400 text-sm flex items-center justify-between cursor-pointer px-2"
      @click.stop="showUsers = !showUsers"
    >
      <div class="OverviewsItemNameWrapper flex items-center w-full">
        <aw-icon
          icon="page"
          class="w-6 h-6 mr-2"
        />
        <span class="OverviewsItemName truncate">
          {{ file.filename }}
        </span>
      </div>
      <div class="flex items-center text-gray-400">
        <span class="">
          {{ file.downloads.length }}
        </span>
        <aw-icon 
          :icon="showUsers ? 'chevron-up' : 'chevron-down'" 
          class="w-6 h-6 ml-2 toggleIcon"
        />
      </div>
    </div>
    <div 
      v-if="showUsers && file.downloads && file.downloads?.length > 0"
      class="flex justify-start items-start flex-col w-full"
    >
      <div 
        v-for="(download, i) in file.downloads"
        :key="i"
        class="OverviewsItemDetail hover:bg-gray-100 flex justify-between items-center space-x-2 w-full border-b border-gray-400 text-sm px-2"
      >
        <span class="text-gray-400 text-sm pl-6">
          {{ download.user.label }}
        </span>
        <span class="text-gray-400 text-sm pr-6">
          {{ $t('Last download') }}: {{ formatDate(download.created, 'd. m. Y') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: Object,
  },
  data() {
    return {
      showUsers: false,
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.OverviewsStatisticsDownload {
  .OverviewsItem:hover .toggleIcon {
    @apply text-bc-blue;
  }

  .OverviewsItemDetail {
    height: 40px;
  }

  .OverviewsItemNameWrapper {
    max-width: calc(100% - 50px);
  }

  .OverviewsItemName {
    max-width: calc(100% - 30px);
  }
}
</style>
